module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00722.39699106.jpg";